import Vue from 'vue';
import { AclInstaller, AclCreate, AclRule } from 'vue-acl';
import router from '@/router';

Vue.use(AclInstaller);

let initialRole = 'all';

export default new AclCreate({
  initial  : initialRole,
  notfound : '/pages/not-authorized',
  router,
  acceptLocalRules : true,
  globalRules: {
    gotu: new AclRule('gotu').generate(),
    admin  : new AclRule('admin').or('gotu').generate(),
    editor : new AclRule('editor').or('admin').generate(),    
    express: new AclRule('express').or('admin').or('gotu').generate(),
    all: new AclRule('all').or('express').or('admin').or('gotu').generate()
  }
});
